<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="400"
  >
    <v-card>
      <v-card-title class="text-h5">
        Reject Party Card
      </v-card-title>
      <v-card-text>Want to reject this section <b>({{ title }})</b>? <br> You can't undo this.</v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="green darken-1"
          text
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="onCardReject"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PEPartySurveyRejectDialog',

  props: {
    onCardReject: {
      type: Function,
      required: true,
    },

    title: {
      type: String,
      required: true,
    },

    value: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    dialog: {
      get () { return this.value },

      set (val) {
        this.$emit('input', val)
      },
    },
  },
}
</script>
